import { create } from "zustand";
import type { Room } from "@spieleparadies/shared";

interface ChatMessage {
  playerId: string;
  playerName: string;
  text: string;
  ts: number;
}

interface RoomState {
  room: Room | null;
  chat: ChatMessage[];
  setRoom: (room: Room | null) => void;
  addChatMessage: (msg: ChatMessage) => void;
  clearChat: () => void;
}

export const useRoomStore = create<RoomState>((set) => ({
  room: null,
  chat: [],
  setRoom: (room) => set({ room }),
  addChatMessage: (msg) =>
    set((state) => ({ chat: [...state.chat, msg].slice(-100) })),
  clearChat: () => set({ chat: [] }),
}));
